import React from "react";
import { CalendarClock, ExternalLink } from "lucide-react";
import { allPosts, nyToday } from "../seo/schema";

const fmt = (d) => new Date(`${d}T12:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
const daysUntil = (d, today) => Math.round((new Date(`${d}T00:00:00Z`) - new Date(`${today}T00:00:00Z`)) / 86400000);

const BlogCalendar = () => {
  const today = nyToday();
  const posts = [...allPosts].sort((a, b) => a.publishDate.localeCompare(b.publishDate));
  const upcoming = posts.filter((p) => p.publishDate > today);
  return (
    <section data-testid="admin-blog-calendar" className="bg-[#111111] border border-white/10 p-5">
      <div className="flex items-center justify-between gap-4 mb-4">
        <h2 className="font-cond font-bold uppercase tracking-widest text-white text-lg flex items-center gap-2">
          <CalendarClock size={18} className="text-[#E50914]" /> Blog Calendar
        </h2>
        <span data-testid="admin-blog-upcoming-count" className="font-cond uppercase tracking-widest text-xs text-white/60">
          {upcoming.length} scheduled • {posts.length - upcoming.length} live • New York time
        </span>
      </div>
      <ul className="divide-y divide-white/10">
        {posts.map((p) => {
          const n = daysUntil(p.publishDate, today);
          const live = n <= 0;
          return (
            <li key={p.slug} data-testid={`admin-blog-row-${p.slug}`} className="py-3 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
              <span className="font-cond uppercase tracking-widest text-xs text-white/70 w-28 shrink-0">{fmt(p.publishDate)}</span>
              <span className="text-white text-sm flex-1">{p.title}</span>
              <span
                data-testid={`admin-blog-status-${p.slug}`}
                className={`font-cond uppercase tracking-widest text-[10px] px-3 py-1 rounded-full shrink-0 ${live ? "bg-[#1B8A5A]/20 text-[#4ADE80]" : "bg-[#D4AF37]/15 text-[#D4AF37]"}`}
              >
                {live ? "Live" : n === 1 ? "Goes live tomorrow" : `Scheduled • in ${n} days`}
              </span>
              {live && (
                <a href={`/blog/${p.slug}`} target="_blank" rel="noopener noreferrer" data-testid={`admin-blog-view-${p.slug}`} className="text-white/50 hover:text-white shrink-0" aria-label="View post">
                  <ExternalLink size={15} />
                </a>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default BlogCalendar;
